import script from "./AltarCandle.vue?vue&type=script&setup=true&lang=js"
export * from "./AltarCandle.vue?vue&type=script&setup=true&lang=js"

import "./AltarCandle.vue?vue&type=style&index=0&id=330ab4fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-330ab4fa"]])

export default __exports__